<script setup lang="ts">
import { useProductStore } from '~/store/product/productStore';

const productStore = useProductStore();
const {
  offer,
  getDeliveryInfo,
  getDeliveryPrice
} = storeToRefs(productStore);
</script>

<template>
  <div>
    <div class="size--headline mb-1">
      <span v-if="offer.details.displayMerchantName" class="hover-underline pointer" data-modal-trigger="modal-merchant-info" v-html="$t('www.product.send_and_delivery_display_merchant', {'merchantName': offer.details.merchantName})"/>
      <span v-else>{{ $t('www.product.send_and_delivery') }}</span>
    </div>
    <div class="df jcsb fdc">
      <div class="df aic fg1">
        <svg class="cicon cicon--f-primary cicon--24 pe-n ct-blue mr-1">
          <use xlink:href="#livraison-express"/>
        </svg>
        <div class="weight--interregular pe-n fg1">
          <div class="size--headline">
            <div>
              {{ getDeliveryInfo }}
            </div>
          </div>
          <div class="df jcsb aic sm-fdc sm-aifs">
            <div class="size--headline weight--interbold c-green-std">
              {{ getDeliveryPrice }}
            </div>
            <div class="size--headline weight--interregular pe-n df aic wsnw">
              <span class="capitalize-first-letter lowercase-text">{{ offer.details.bestShipping.estimationDates }}</span>
            </div>
          </div>
          <span v-if="offer.details.returnItem">{{ offer.details.returnItem.message }}</span>
          <div v-if="offer.details.isAvailableExpressDelivery" class="size--headline weight--interregular italic-text pe-n">
            <span>{{ $t('www.product.express_delivery') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="offer.details.freeReturn" class="df aic fdr mt-2">
      <svg class="cicon cicon--24 pe-n ct-blue mr-1">
        <use xlink:href="#satisfait"/>
      </svg>
      <div class="weight--interregular pe-n">
        <div class="size--headline">
          <div v-html="$t('www.product.return_is_free-v3', {'class': 'c-green-std weight--interbold', 'days': offer.details.returnPeriod})"/>
        </div>
      </div>
    </div>
  </div>
</template>
